(() => {
  'use strict';
  if (window.__tmProductReviewSections) {
    window.__tmProductReviewSections.mountWithin(document);
    return;
  }
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const events = new AbortController();
    const listen = (target, type, listener, options = {}) => target?.addEventListener(type, listener, {...options, signal: events.signal});
    const body = document.body;
    let active = true, frame = 0, focusFrame = 0;
    function update() {
      frame = 0;
      if (!active || !root.isConnected) return;
      const nav = document.querySelector('[data-product-subnav]');
      const box = root.getBoundingClientRect();
      const reading = box.top < innerHeight * .5 && box.bottom > innerHeight * .35;
      body.classList.toggle('is-reading-reviews', reading);
      body.classList.toggle('is-review-editing', [...root.querySelectorAll('form')].some(form => !form.hidden && form.getClientRects().length > 0));
      root.style.setProperty('--review-scroll-top', ((nav?.classList.contains('is-visible') ? nav.getBoundingClientRect().height : 0) + 20) + 'px');
      if (reading) {
        const link = nav?.querySelector('a[href="#pdp-reviews"]'), strip = link?.parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth) {
          const a = link.getBoundingClientRect(), b = strip.getBoundingClientRect();
          if (a.left < b.left || a.right > b.right) strip.scrollLeft += a.left - b.left - (b.width - a.width) / 2;
        }
      }
    }
    function schedule() { if (active && !frame) frame = requestAnimationFrame(update); }
    function revealField(field) {
      if (!active || !field || !root.contains(field) || !field.matches('input,select,textarea')) return;
      update();
      cancelAnimationFrame(focusFrame);
      focusFrame = requestAnimationFrame(() => {
        focusFrame = 0;
        if (!active || !field.isConnected) return;
        const nav = document.querySelector('[data-product-subnav]'), dock = document.querySelector('[data-purchase-dock]');
        const vv = window.visualViewport, offset = vv?.offsetTop || 0;
        const top = offset + (nav?.classList.contains('is-visible') ? nav.getBoundingClientRect().height : 0) + 20;
        const dockHeight = dock && getComputedStyle(dock).visibility !== 'hidden' ? dock.getBoundingClientRect().height : 0;
        const bottom = offset + (vv?.height || innerHeight) - dockHeight - 20;
        const rect = field.getBoundingClientRect();
        if (rect.top < top || rect.bottom > bottom) window.scrollBy({top: rect.top - (top + Math.max(0, (bottom - top - rect.height) / 2)), behavior: 'instant'});
      });
    }
    listen(root, 'focusin', event => revealField(event.target));
    const observer = new MutationObserver(schedule);
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'open', 'aria-expanded']});
    listen(window, 'scroll', schedule, {passive: true});
    listen(window, 'resize', () => { schedule(); revealField(document.activeElement); });
    listen(window.visualViewport, 'resize', () => revealField(document.activeElement));
    listen(window, 'pagehide', () => { cancelAnimationFrame(frame); cancelAnimationFrame(focusFrame); frame = focusFrame = 0; });
    listen(window, 'pageshow', schedule);
    document.fonts.ready.then(() => { if (active) schedule(); });
    instances.set(root, {
      schedule,
      destroy() {
        active = false;
        events.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
        cancelAnimationFrame(focusFrame);
        body.classList.remove('is-reading-reviews', 'is-review-editing');
        root.style.removeProperty('--review-scroll-top');
        instances.delete(root);
      }
    });
    update();
  }
  function mountWithin(parent) {
    if (parent.matches?.('#pdp-reviews')) mount(parent);
    parent.querySelectorAll('#pdp-reviews').forEach(mount);
  }
  window.__tmProductReviewSections = {mountWithin};
  mountWithin(document);
  document.addEventListener('shopify:section:load', event => { mountWithin(event.target); instances.forEach(instance => instance.schedule()); });
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, instance] of instances) if (event.target === root || event.target.contains(root)) instance.destroy();
  });
  document.addEventListener('shopify:section:reorder', () => instances.forEach(instance => instance.schedule()));
})();
